import { render, staticRenderFns } from "./OemDefectiveLogisticsDialog.vue?vue&type=template&id=18e9e1fa&"
import script from "./OemDefectiveLogisticsDialog.vue?vue&type=script&lang=js&"
export * from "./OemDefectiveLogisticsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports